<template>
    <div class="date-range-picker-double flex justify-between">
        <a-date-picker
            :value="modelValue.start_date"
            :disabled-date="disabledStartDate"
            :allowClear="allowClear"
            :disabled="disabled"
            class="appearance-none inline-block mr-1 w-1/2"
            :format="format"
            :show-time="show_time"
            placeholder="Start Date"
            data-cy="range-date-start-picker"
            @openChange="onStartOpenChange"
            @change="onStartDateChange"
        />
        <a-date-picker
            :value="modelValue.end_date"
            :disabled-date="disabledEndDate"
            :allowClear="allowClear"
            :disabled="disabled"
            class="appearance-none inline-block mr-1 w-1/2"
            :format="format"
            :show-time="show_time"
            placeholder="End Date"
            data-cy="range-date-end-picker"
            :open="end_open"
            @openChange="onEndOpenChange"
            @change="onEndDateChange"
        />
    </div>
</template>

<script>
export default {
    data() {
        return {
            start_value: null,
            end_value: null,
            end_open: false,
        };
    },
    props: {
        modelValue: {
            type: Object,
            default: () => ({
                start_date: null,
                end_date: null,
            }),
        },
        date_limits: {
            type: Object,
            default: () => ({
                start_date: null,
                end_date: null,
            }),
        },
        section: { type: String, default: 'default' },
        disabled: {
            type: Boolean,
            default: false,
        },
        allowClear: {
            type: Boolean,
            default: true,
        },
        format: {
            type: String,
            default: 'YYYY-MM-DD',
        },
        show_time: {
            type: [Object, Boolean],
            default: false,
        },
    },
    mounted() {
        this.start_value = this.modelValue.start_date;
        this.end_value = this.modelValue.end_date;
    },
    methods: {
        disabledStartDate(start_value) {
            let end_value = this.end_value;
            let limits = this.date_limits;

            if (end_value != null && start_value != null) {
                if (limits.start_date != null && limits.end_date != null) {
                    return (
                        limits.start_date.valueOf() > start_value.valueOf() ||
                        start_value.valueOf() > limits.end_date.valueOf()
                    );
                } else if (limits.start_date != null) {
                    return (
                        limits.start_date.valueOf() > start_value.valueOf() ||
                        start_value.valueOf() > end_value.valueOf()
                    );
                } else {
                    return start_value.valueOf() > end_value.valueOf();
                }
            } else {
                return false;
            }
        },
        disabledEndDate(end_value) {
            let start_value = this.start_value;
            let limits = this.date_limits;

            if (end_value != null && start_value != null) {
                if (limits.start_date != null && limits.end_date != null) {
                    return (
                        end_value.valueOf() < limits.start_date.valueOf() ||
                        limits.end_date.valueOf() < end_value.valueOf()
                    );
                } else if (limits.end_date != null) {
                    return (
                        end_value.valueOf() < start_value.valueOf() ||
                        start_value.valueOf() > end_value.valueOf() ||
                        limits.end_date.valueOf() < end_value.valueOf()
                    );
                } else {
                    return start_value.valueOf() > end_value.valueOf();
                }
            } else {
                return false;
            }
        },
        onStartOpenChange(open) {
            if (!open) {
                this.end_open = true;
            }
        },
        onEndOpenChange(open) {
            this.end_open = open;
        },
        onStartDateChange(date, date_string) {
            let date_object_start = this.$dayjs(date_string, 'YYYY-MM-DD');

            if (!date_object_start.isValid()) {
                date_object_start = null;
            }

            this.start_value = date_object_start;

            this.$emit('update:modelValue', {
                start_date: this.start_value,
                end_date: this.end_value,
            });

            this.$emit('changeDates', {
                start_date: this.start_value,
                end_date: this.end_value,
            });
        },
        onEndDateChange(date, date_string) {
            let date_object_end = this.$dayjs(date_string, 'YYYY-MM-DD');

            if (!date_object_end.isValid()) {
                date_object_end = null;
            }

            this.end_value = date_object_end;

            this.$emit('update:modelValue', {
                start_date: this.start_value,
                end_date: this.end_value,
            });

            this.$emit('changeDates', {
                start_date: this.start_value,
                end_date: this.end_value,
            });
        },
    },
};
</script>
